import React from 'react'
import ComingSoon from '../../components/ProgramProvider/ComingSoon'
import Footer from '../../components/Footer'
const ProgramProvider = () => {
  return (
    <>
    <ComingSoon/>
    
    </>
  )
}

export default ProgramProvider